import config from '@/app-config'
import router from '@/router'
import { store } from '@/store/store'
import axios from 'axios'

export default {
  async authDefault(creds) {
    try {
      var response = await axios.post(config.serverUrl + 'login', {
        userid: creds.userid,
        password: creds.password,
        'g-recaptcha-response': creds['g-recaptcha-response']
      })

      response = response.data
      if (response.responsecode === 200) {
        return Promise.resolve(response)
      } else if (response.responsecode === 400) {
        let message = response.reason ? response.reason : 'Something went wrong, please try again'
        store
          .dispatch('logout', {
            error: { code: response.responsecode, message: message }
          })
          .then(function() {
            router.push('/' + store.getters.currentLang + '/login')
          })

        // router.push('/nigol')
        return Promise.reject(new Error(message))
      } else {
        if (response.reason) {
          return Promise.reject(new Error(response.reason))
        } else {
        }
      }
    } catch (error) {
      this.defaultError(error, err => {
        return Promise.reject(err)
      })
    }
  },

  getLongLiveToken: function(creds, callback) {
    axios
      .get(
        config.serverUrl +
          'getlonglivetoken?appid=' +
          config.appid +
          '&accesstoken=' +
          creds.accessToken
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPageList: function(data, callback) {
    axios
      .get(
        'https://graph.facebook.com/v3.1/me/accounts?access_token=' +
          data.token +
          '&limit=1000&fields=access_token,category,category_list,id,tasks,name,name_with_location_descriptor'
      )
      .then(response => {
        // JSON responses are automatically parsed.
        var response = response.data
        if (response.data) {
          let pagelist = []
          $.each(response.data, function(index, value) {
            var page = Object.assign({}, value)
            page.name = page.name_with_location_descriptor

            if (value.perms) {
              if (
                value.perms.indexOf('ADMINISTER') > -1 ||
                value.perms.indexOf('EDIT_PROFILE') > -1
              ) {
                pagelist.push(page)
              }
            }
            if (value.tasks) {
              if (
                value.tasks.indexOf('MANAGE') > -1 ||
                value.tasks.indexOf('CREATE_CONTENT') > -1
              ) {
                pagelist.push(page)
              }
            }
          })
          callback(null, pagelist)
        } else {
          callback(new Error(response.reason))
        }
      })
      .catch(e => {
        callback(new Error('session expire. Please login again.'))
      })
  },

  getBotList: function(data, token, callback) {
    axios.defaults.headers.common = {
      authorization: token
    }
    axios
      .post(config.serverUrl + 'checkbotlist', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAllPublicTheme: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getallpublictheme?appid=')
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  toggleBotStatus: function(data, callback) {
    let url = !data.status ? 'stopbot' : 'startbot'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  checkBotlist: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'checkbotlist', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getSignedRequest: function(data, callback) {
    let url = config.serverUrl + 'sign-s3?file-name=' + data.name + '&file-type=' + data.type

    axios
      .get(url)
      .then(response => {
        // JSON responses are automatically parsed.
        var response = response.data
        response.file = data.file
        this.uploadfile(response, function() {
          callback(null, response.url)
        })
      })
      .catch(e => {
        callback(new Error('session expire. Please login again.'))
      })
  },

  uploadfile: function(data, callback) {
    let signedRequest = data.signedRequest
    let request = data.file
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', signedRequest)
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          callback()
        } else {
          alert('Could not upload file.')
        }
      }
    }
    xhr.send(request)
  },
  uploadfileV2: async function(data) {
    // axios.defaults.headers.common = {
    //   // AUTHORIZATION: store.getters.securityToken
    //   Authorization: 'Basic YWRtaW46QWRtaW5wYXNzd29yZDE='
    // }
    delete axios.defaults.headers.common['AUTHORIZATION']
    try {
      var response = await axios.post(`https://apis.psyjai.com/uploadS3`, data)
      if (response.data.url) {
        return Promise.resolve(response.data.url)
      } else {
        throw new Error('Image url is not found')
      }
    } catch (error) {
      return Promise.reject(error)
    }
  },

  saveWelcomeMessage: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'botwelcomemessage', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getWelcomeMessage: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'botwelcomemessage?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'intents', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  addIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'intents', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'intents?id=' + data['id'], data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'intents', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getSetting: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getallcontent?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getBotDetail: function(data, callback) {
    // console.log(store.getters.securityToken)
    if (!data['pageid']) {
      return false
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'checkbotpage?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getConversationDropdown: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getdropdown')
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getFlowList: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'flowlist', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getPublicFlowList: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'publicflowlist', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  addFlowDetail: function(data) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      axios
        .post(config.serverUrl + 'flowdetail', data)
        .then(response => {
          this.defaultResponse(response, function(err, response) {
            if (err) {
              reject(err)
            }
            resolve(response)
          })
        })
        .catch(e => {
          this.defaultError(e, function(error) {
            reject(error)
          })
        })
    })
  },
  editFlowDetail: function(data) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      axios
        .put(config.serverUrl + 'flowdetail?id=' + data['id'], data)
        .then(response => {
          this.defaultResponse(response, function(err, response) {
            if (err) {
              reject(err)
            }
            resolve(response)
          })
        })
        .catch(e => {
          this.defaultError(e, function(error) {
            reject(error)
          })
        })
    })
  },
  deleteFlowDetail: function(data) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      axios
        .delete(config.serverUrl + 'flow?id=' + data['id'])
        .then(response => {
          this.defaultResponse(response, function(err, response) {
            if (err) {
              reject(err)
            }
            resolve(response)
          })
        })
        .catch(e => {
          this.defaultError(e, function(error) {
            reject(error)
          })
        })
    })
  },
  getFlowAllIntents: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'dragdrop/allintents', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  editFlow: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'flowdetail?id=' + data['id'], data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  addNode: function(data) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      axios
        .post(config.serverUrl + 'dragdrop/intent', data)
        .then(response => {
          this.defaultResponse(response, function(err, response) {
            if (err) {
              reject(err)
            }
            resolve(response)
          })
        })
        .catch(e => {
          this.defaultError(e, function(error) {
            reject(error)
          })
        })
    })
  },
  editNode: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'dragdrop/intent?id=' + data['id'], data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteNode: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'dragdrop/intent?id=' + data['id'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getApiList: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'dragdrop/allapis')
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  addApi(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'dragdrop/api', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  editApi(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(`${config.serverUrl}dragdrop/api?id=${data.id}`, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteApi(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(`${config.serverUrl}dragdrop/api?id=${data.id}`)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getAllVariable(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'dragdrop/allvariables')
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  addVariable: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'dragdrop/variable', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  editVariable: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(`${config.serverUrl}dragdrop/variable?id=${data.id}`, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteVariable: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(`${config.serverUrl}dragdrop/variable?id=${data.id}`)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveVariablePossibleOutput(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(`${config.serverUrl}dragdrop/variablesfromapis`, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getVariablePossibleOutput(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'dragdrop/variablesfromapis?variable_name=' + data.name)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getAllAdmins() {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      axios
        .get(config.serverUrl + 'alladmins')
        .then(response => {
          this.defaultResponse(response, function(err, response) {
            if (err) {
              reject(err)
            }
            resolve(response)
          })
        })
        .catch(e => {
          this.defaultError(e, function(error) {
            reject(error)
          })
        })
    })
  },
  getAllFlow() {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      axios
        .get(config.serverUrl + 'allflow')
        .then(response => {
          this.defaultResponse(response, function(err, response) {
            if (err) {
              reject(err)
            }
            resolve(response)
          })
        })
        .catch(e => {
          this.defaultError(e, function(error) {
            reject(error)
          })
        })
    })
  },
  addAdmin: function(data) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      axios
        .post(config.serverUrl + 'admin', data)
        .then(response => {
          this.defaultResponse(response, function(err, response) {
            if (err) {
              reject(err)
            }
            resolve(response)
          })
        })
        .catch(e => {
          this.defaultError(e, function(error) {
            reject(error)
          })
        })
    })
  },
  editAdmin: function(data) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      axios
        .put(config.serverUrl + 'adminflowidlist?adminid=' + data['adminid'], data)
        .then(response => {
          this.defaultResponse(response, function(err, response) {
            if (err) {
              reject(err)
            }
            resolve(response)
          })
        })
        .catch(e => {
          this.defaultError(e, function(error) {
            reject(error)
          })
        })
    })
  },
  deleteAdmin: function(data) {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      axios
        .delete(config.serverUrl + 'admin?adminid=' + data['adminid'])
        .then(response => {
          this.defaultResponse(response, function(err, response) {
            if (err) {
              reject(err)
            }
            resolve(response)
          })
        })
        .catch(e => {
          this.defaultError(e, function(error) {
            reject(error)
          })
        })
    })
  },

  changepassword(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'changepassword', data)

      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  addbotorigin(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'botorigin', data)

      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAllBotOrigins() {
    return new Promise((resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      axios
        .get(config.serverUrl + 'allbotorigins')
        .then(response => {
          this.defaultResponse(response, function(err, response) {
            if (err) {
              reject(err)
            }
            resolve(response)
          })
        })
        .catch(e => {
          this.defaultError(e, function(error) {
            reject(error)
          })
        })
    })
  },

  getallusersbybotorigin(request) {
    return new Promise(async (resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      try {
        var response = await axios.get(config.serverUrl + 'allusersbybotorigin', {
          params: request
        })
        this.defaultResponse(response, function(err, response) {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      } catch (e) {
        this.defaultError(e, function(error) {
          reject(error)
        })
      }
    })
  },

  saveusercurrentvariables(request) {
    return new Promise(async (resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      try {
        var response = await axios.put(config.serverUrl + 'usercurrent_variables', request.data, {
          params: request.params
        })
        this.defaultResponse(response, function(err, response) {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      } catch (e) {
        this.defaultError(e, function(error) {
          reject(error)
        })
      }
    })
  },

  getallvariablestransaction(request) {
    return new Promise(async (resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      try {
        var response = await axios.get(config.serverUrl + 'allvariablestransaction', {
          params: request
        })
        this.defaultResponse(response, function(err, response) {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      } catch (e) {
        this.defaultError(e, function(error) {
          reject(error)
        })
      }
    })
  },

  getallbotorigins(request) {
    return new Promise(async (resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      try {
        var response = await axios.get(config.serverUrl + 'allbotorigins', {
          params: request
        })
        this.defaultResponse(response, function(err, response) {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      } catch (e) {
        this.defaultError(e, function(error) {
          reject(error)
        })
      }
    })
  },

  deletebotorigin(request) {
    return new Promise(async (resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      try {
        var response = await axios.delete(config.serverUrl + 'botorigin', { params: request })

        this.defaultResponse(response, function(err, response) {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      } catch (e) {
        this.defaultError(e, function(error) {
          reject(error)
        })
      }
    })
  },

  getbroadcast(request) {
    return new Promise(async (resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      try {
        var response = await axios.get(config.serverUrl + 'broadcast', {
          params: request
        })
        this.defaultResponse(response, function(err, response) {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      } catch (e) {
        this.defaultError(e, function(error) {
          reject(error)
        })
      }
    })
  },

  sendBroadcast({ data, params }) {
    return new Promise(async (resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      try {
        var response = await axios.post(config.serverUrl + 'broadcast', data, {
          params: params
        })
        this.defaultResponse(response, function(err, response) {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      } catch (e) {
        this.defaultError(e, function(error) {
          reject(error)
        })
      }
    })
  },

  deletebroadcast(request) {
    return new Promise(async (resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      try {
        var response = await axios.delete(config.serverUrl + 'broadcast', {
          params: request
        })

        this.defaultResponse(response, function(err, response) {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      } catch (e) {
        this.defaultError(e, function(error) {
          reject(error)
        })
      }
    })
  },

  getPersistentMenu(request) {
    return new Promise(async (resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      try {
        var response = await axios.get(config.serverUrl + 'messenger_profile', {
          params: request
        })
        this.defaultResponse(response, function(err, response) {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      } catch (e) {
        this.defaultError(e, function(error) {
          reject(error)
        })
      }
    })
  },

  savePersistentMenu(request) {
    return new Promise(async (resolve, reject) => {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      try {
        var response = await axios.post(config.serverUrl + 'messenger_profile', request.data, {
          params: request.params
        })
        this.defaultResponse(response, function(err, response) {
          if (err) {
            reject(err)
          }
          resolve(response)
        })
      } catch (e) {
        this.defaultError(e, function(error) {
          reject(error)
        })
      }
    })
  },
  //end

  // =============== default function =================

  defaultResponse: function(response, callback) {
    response = response.data
    if (response.responsecode === 200) {
      callback(null, response)
    } else if (response.responsecode === 400) {
      let message = response.reason ? response.reason : ''
      store.dispatch('logout', { code: response.responsecode, message: message }).then(function() {
        router.push('/' + store.getters.currentLang + '/login')
        callback(new Error('Session expire. Please login again.'))
      })
    } else {
      if (response.reason) {
        callback(new Error(response.reason))
      } else {
      }
    }
  },

  defaultError: function(e, callback) {
    if (process.env.NODE_ENV !== 'production') {
      console.error(e)
    }
    callback(new Error('Session expire. Please login again.'))
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js